<template>
    <v-container fluid>
        <div v-for="component in coms" :key="component.id">
            <Appbar v-bind:id="component.id"
                    v-bind:name="component.name"
                    v-bind:title="component.title"
                    v-bind:icon="component.icon"
                    v-bind:opened="component.opened"
                    v-bind:clickable="component.clickable"
                    v-bind:resetData="component.resetData"
                    v-bind:selected="component.selected"
                    v-bind:formModel="formModel" />
        </div>
        <v-btn @click="submitForm()"
               :color="`${submitButtonBackgroundColor}`"
               :style="'color: `${submitButtonColor}`' "
               :disabled="!valid"
               large>
            Verzenden
        </v-btn>
    </v-container>
</template>


<script>
    /* eslint-disable */
    import { mapState, mapActions } from "vuex";
    import Appbar from "../components/Appbar";
    import { services } from "../_services";

    const formModel = {
        clientFirstName: null,
        clientPrefixName: null,
        clientLastName: null,
        clientBirthDay: 0,
        clientBirthMonth: 0,
        clientBirthYear: 0,
        clientZipCode: null,
        clientHuisnummer: null,
        clientHuisnummerToevoeging: null,
        clientEmail: null,
        clientPhone: null,
        trajectId: 0,
        appointmentType: null,
        appointmentId: null,
        appointmentMoment: null,
        therapeutId: 0,
        locatieId: 0,
        appointmentName: null,
        locatieName: null,
        therapeutName: null,
        therapeutDescription: null,
        firstSlot: null,
        categoryId: 0,
        categoryTitle: null,
        dataPermission: false,
    };

    const coms = [
        {
            id: 1,
            name: "appointment-type",
            title: "Kies type afspraak",
            icon: "fa-list-alt",
            opened: true,
            clickable: true,
            resetData: false,
            selected: false,
        },
        {
            id: 2,
            name: "category",
            title: "Waar heeft u klachten of waar heeft u last van?",
            icon: "fa-list-alt",
            opened: false,
            clickable: false,
            resetData: false,
            selected: false,
        },
        {
            id: 3,
            name: "therapists-list",
            title: "Kies therapeut",
            icon: "fa-user",
            opened: false,
            clickable: false,
            resetData: true,
            selected: false,
        },
        {
            id: 4,
            name: "time-slots",
            title: "Kies tijd",
            icon: "fa-calendar-alt",
            opened: false,
            clickable: false,
            resetData: false,
            selected: false,
        },
        {
            id: 5,
            name: "contact-form",
            title: "Voer contactgegevens in",
            icon: "fa-id-card",
            opened: false,
            clickable: false,
            resetData: false,
            selected: false,
        },
    ];

    export default {
        name: "Home",
        components: {
            Appbar,
        },
        data: () => ({
            submitButtonColor: "",
            submitButtonBackgroundColor: "",
            coms: null,
            formModel: null,
            validContactInfo: false,
            valid: false,
            isSubmitted: false,
            confirmationRouterName: "Confirmation",
            postFormModelRoute: "confirmappointment",
        }),
        computed: {
            ...mapState("app", ["status", "siteInfo"]),
            ...mapState({
                appBar: (state) => state.appBar,
            }),
            getSelectedAppBarId() {
                return this.appBar.selection;
            },
            getFormModel() {
                return this.appBar.formModel;
            },
        },
        methods: {
            ...mapActions("app", ["getSiteInfo"] ),
            ...mapActions({
                clearAlert: "alert/clear",
                showAlert: "alert/error",
            }),
            ...mapActions({
                loaderSetColor: "loader/setColor",
                loaderStart: "loader/start",
                loaderStop: "loader/stop",
                loaderClear: "loader/clear",
                updateFormModel: "appBar/updateFormModel",
            }),
            closeSelectedAppBars() {
                this.coms.forEach((element) => {
                    if (element.selected == true) {
                        element.clickable = true;
                        element.opened = false;
                    }
                });
            },
            openUnselectedAppBar() {
                var doneSelectionComponent = this.coms.find((x) => x.selected == false);
                doneSelectionComponent.clickable = true;
                doneSelectionComponent.opened = true;
            },
            submitForm() {
                if (!this.isSubmitted) {
                    this.isSubmitted = true;
                    this.clearAlert();
                    this.loaderSetColor("#29d"); //paremeter: loader color
                    this.loaderStart();
                    services.postFormModel(this.formModel, this.postFormModelRoute).then(
                        (data) => {
                            var vm = this;

                            //URL MUST Have https:// for window.location.href to work
                            if (this.checkValidationOfLinkBackToUrl()) {
                                window.top.location.href = this.siteInfo.linkBackToUrl;
                            } else {
                                vm.$router.push({
                                    name: this.confirmationRouterName,
                                    params: { confirmationModel: data },
                                });

                                this.loaderStop();
                                this.loaderClear();
                            }
                        },
                        (error) => {
                            this.isSubmitted = false;
                            this.loaderSetColor("#f44336"); //paremeter: loader color
                            this.loaderStop();
                            this.loaderClear();
                            this.showAlert(error);
                        }
                    );
                }
            },
            checkFilledUpAppointmentInformation() {
                if (
                    this.formModel.appointmentType != null &&
                    //this.formModel.locatieId != 0 &&
                    this.formModel.therapeutId != 0 &&
                    this.formModel.appointmentId != null
                ) {
                    return true;
                }

                return false;
            },
            checkValidationOfLinkBackToUrl() {
                return (this.siteInfo.linkBackToUrl && this.siteInfo.linkBackToUrl.includes("https://"));
            },
        },
        mounted: function () {
            this.getSiteInfo();
            this.formModel = formModel;
            this.validContactInfo = formModel.dataPermission;
        },
        watch: {
            getFormModel(value) {
                this.formModel = { ...this.formModel, ...value };

                var selectedComponent = this.coms.find((x) => x.id == value.id);

                if (selectedComponent != null) {
                    selectedComponent.selected = value.selected;
                }

                this.validContactInfo = this.formModel.dataPermission;
                this.valid = false;
                if (
                    this.checkFilledUpAppointmentInformation() == true &&
                    this.validContactInfo == true
                ) {
                    this.valid = true;
                }
            },
            // eslint-disable-next-line no-unused-vars
            status(newValue, oldValue) {
                // VanuitPraktijkWebsite = 0,
                // NieuweAfspraakVanuitPortal = 1,
                // VervolgAfspraakVanuitPortal = 2
                if (newValue.requestSuccess && newValue.requestSuccess === true) {
                    this.submitButtonBackgroundColor = this.siteInfo.colorInfo.submitButtonBackgroundColor;
                    this.submitButtonColor = this.siteInfo.colorInfo.submitButtonColor;

                    if (this.siteInfo.appointmentUseCase > 0) {
                        this.confirmationRouterName = "ConfirmationPortal";
                        this.postFormModelRoute = "confirmappointmentportal";
                        coms.find(x => x.id === 5).title = "Samenvatting afspraak";
                        this.updateFormModel({
                            formModel: {
                                ...this.siteInfo.afspraakVanuitPraktijkWebsite,
                            },
                        });
                        if (this.siteInfo.appointmentUseCase == 2) {
                            let comIndex = coms.findIndex(x => x.id === 1);

                            coms[comIndex].opened = false;
                            coms[comIndex].clickable = false;

                            coms.unshift({
                                id: 0,
                                name: "followupprocedure",
                                title: "Voor welk traject wilt u een afspraak maken?",
                                icon: "fa-folder",
                                opened: true,
                                clickable: true,
                                resetData: false,
                                selected: false,
                            });
                        }
                    }
                    this.coms = coms;
                }
            },
            getSelectedAppBarId(selection) {
                this.coms.forEach((element) => {
                    if (element.id < selection.id) {
                        element.resetData = false;
                    }
                });

                if (selection.type == "select") {
                    //(selection type: select) = the appBar input(s) is/are selected
                    this.coms.forEach((element) => {
                        if (selection.emptySelection == true && element.id >= selection.id) {
                            if (element.id > selection.id) {
                                element.clickable = false;
                                element.opened = false;
                            }
                            if (selection.resetData == true) {
                                element.resetData = true;
                                element.selected = false;
                            }
                        } else if (
                            selection.resetData == true &&
                            element.id >= selection.id
                        ) {
                            if (element.id == selection.id) {
                                element.resetData = true;
                                element.selected = false;
                            } else if (element.id > selection.id) {
                                element.resetData = true;
                                element.opened = false;
                                element.selected = false;
                                element.clickable = false;
                            }
                        } else {
                            if (element.selected == true) {
                                element.clickable = true;
                                element.opened = false;
                            }
                        }
                    });
                    this.openUnselectedAppBar();

                } else if (selection.type == "navigate") {
                    //(selection type: navigate) = the appBar header is clicked
                    var prevSelectedComponent = this.coms.find((x) => x.opened == true);
                    prevSelectedComponent.opened = false;
                    prevSelectedComponent.clickable = true;

                    var selectedComponent = this.coms.find((x) => x.id == selection.id);
                    selectedComponent.clickable = true;
                    selectedComponent.opened = true;
                }

                if (typeof selection.callback === "function") {
                    selection.callback();
                }
            },
        },
    };
</script>